type ErrorPageLocale = 'fr' | 'nl' | 'en' | 'de';

type ErrorPageMessages = {
    title: string;
    text: string;
    reload: string;
};

const SUPPORTED: ErrorPageLocale[] = ['fr', 'nl', 'en', 'de'];

const MESSAGES: Record<ErrorPageLocale, ErrorPageMessages> = {
    fr: {
        title: 'Une erreur est survenue',
        text: 'Une erreur inattendue est survenue.',
        reload: "Recharger l'application",
    },
    nl: {
        title: 'Er is een fout opgetreden',
        text: 'Er is een onverwachte fout opgetreden.',
        reload: 'App herladen',
    },
    en: {
        title: 'Something went wrong',
        text: 'An unexpected error occurred.',
        reload: 'Reload the app',
    },
    de: {
        title: 'Ein Fehler ist aufgetreten',
        text: 'Ein unerwarteter Fehler ist aufgetreten.',
        reload: 'App neu laden',
    },
};

const languageSegment = (locale: string, position: 'first' | 'last') => {
    const parts = locale.split('-');
    return (position === 'last' ? parts[parts.length - 1] : parts[0]).toLowerCase();
};

const isSupported = (language: string): language is ErrorPageLocale => SUPPORTED.includes(language as ErrorPageLocale);

const fromStoredLocale = (): ErrorPageLocale | null => {
    try {
        const stored = localStorage.getItem('locale');
        const language = stored ? languageSegment(stored, 'last') : '';
        return isSupported(language) ? language : null;
    } catch {
        return null;
    }
};

const fromBrowserLocale = (): ErrorPageLocale | null => {
    const language = languageSegment(navigator?.language ?? '', 'first');
    return isSupported(language) ? language : null;
};

export const useErrorPageTranslations = (): ErrorPageMessages => {
    const locale = fromStoredLocale() ?? fromBrowserLocale() ?? 'fr';
    return MESSAGES[locale];
};
